import requests from './httpService';

const TodayReportService = {
  getTodayTeacherWork(body = {}) {
    return requests.post('/reports/today-teacher-work', body);
  },
};

export default TodayReportService;
